import { useQuery } from '@tanstack/react-query';
import { supabase } from '../utils/supabaseClient';
import { queryKeys } from '../utils/queryKeys';
import { useQueryError } from './useQueryError';

export function useCardOverlay(cardId) {
  const { handleError } = useQueryError();

  console.log('useCardOverlay - cardId received:', cardId);

  const { data, isLoading, error } = useQuery({
    queryKey: queryKeys.cards.byId(cardId),
    queryFn: async () => {
      try {
        console.log('useCardOverlay - fetching data for cardId:', cardId);
        
        const { data, error } = await supabase
          .from('cards')
          .select(`
            *,
            company_overview (
              companyname,
              description,
              button_color,
              videopreview,
              videopreview_phone,
              companylink,
              keyfeature1_title,
              keyfeature1_description,
              keyfeature2_title,
              keyfeature2_description,
              keyfeature3_title,
              keyfeature3_description,
              keyfeature4_title,
              keyfeature4_description,
              keyfeature5_title,
              keyfeature5_description
            )
          `)
          .eq('id', cardId)
          .single();

        if (error) {
          console.error('useCardOverlay - Supabase error:', error);
          throw error;
        }

        console.log('useCardOverlay - raw data received:', data);

        if (!data || !data.company_overview) {
          console.error('useCardOverlay - Missing data or company_overview');
          throw new Error('Card or company data not found');
        }

        // Devolvemos los datos sin procesar
        return data;
      } catch (error) {
        console.error('useCardOverlay - Error in query function:', error);
        handleError(error);
        throw error;
      }
    },
    enabled: Boolean(cardId),
    staleTime: 1000 * 60 * 5 // 5 minutos
  });

  return {
    data,
    isLoading,
    error
  };
}